export default __webpack_public_path__ + "static/media/password.f1ef7be4.svg";